export enum StatusTypes{
    inactive = 0,
    active = 1,
    all = 2,
}